import React from 'react';

export interface DropDownOption {
  id: string;
  name: string;
}

interface DropDownProps {
  id?: string;
  label?: string;
  value: string;
  options: DropDownOption[];
  onOptionSelect: (id: string) => void;
  style?: React.CSSProperties;
}

const DropDown: React.FC<DropDownProps> = ({ id, label, value, options, onOptionSelect, style }) => {
  return (
    <div style={style}>
      {label && <label htmlFor={id} style={{ marginRight: '8px' }}>{label}</label>}
      <select
        id={id}
        value={value}
        onChange={e => onOptionSelect(e.target.value)}
        style={{ padding: '6px', borderRadius: '2px', border: '1px solid #007AAA', minWidth: '180px' }}
      >
        {options.map(opt => (
          <option key={opt.id} value={opt.id}>{opt.name}</option>
        ))}
      </select>
    </div>
  );
};

export default DropDown;
